// extracted by mini-css-extract-plugin
module.exports = {"noPadding":"AllArtworksCatalogue_noPadding__Vy6_b"};